import {Pipe, PipeTransform} from "@angular/core";
import {DatePipe} from "@angular/common";

@Pipe({
    name: "wbo_date"
})
export class WBODatePipe implements PipeTransform {
    transform(value: any, args?: string): any {
        return new DatePipe("en-GB").transform(value, args || "dd/MM/yyyy");
    }
}
